import { useState, useEffect } from "react";
import Header from "../../components/Header/Header";
import { Container, DivCenter } from "./styles";
import { useHistory, useParams } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import Text from "../Text/text";
import axios from "axios";
import { api } from "../../services/api";

type ParamsProps = {
  id: string;
};

function Terms() {
  const history = useHistory();
  const [checked, setChecked] = useState(false);
  const [disable, setDisable] = useState(true);
  const { id } = useParams<ParamsProps>();
  const [lat, setLat] = useState(0);
  const [lng, setLng] = useState(0);
  const [ip, setIP] = useState(0);
  const [location, setLocation] = useState(false);

  function ValidateTerms() {
    api.post("/checkpolicies", { uuid: id }).then((response) => {
      if (response.data.success === true) {
        history.push(`/success`);
      } else {
      }
    });
  }

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(() => {
      setLocation(true);
    });
  }, []);

  useEffect(() => {
    ValidateTerms();
    Getdata();
  });

  function validateCheckbox() {
    if (checked === true) {
      history.push("/success");
    }
  }

  const Getdata = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    setIP(res.data.IPv4);
    setLat(res.data.latitude);
    setLng(res.data.longitude);
  };

  function SendData() {
    if (location === true) {
      api.post("/recievepolicies", {
        uuid: id,
        ip: ip,
        latitude: lat,
        longitude: lng,
      });
    } else {
      api.post("/recievepolicies", {
        uuid: id,
        ip: null,
        latitude: null,
        longitude: null,
      });
    }
  }

  return (
    <>
      <Header />
      <Container>
        <Text />
        <DivCenter>
          <Checkbox
            onClick={() => {
              setChecked(!checked);
              setDisable(!disable);
            }}
          />
          <p>Eu concordo com os termos</p>
        </DivCenter>
        <DivCenter>
          <button
            disabled={disable}
            color="secondary"
            type="submit"
            onClick={() => {
              SendData();
              validateCheckbox();
            }}
          >
            <p>Continuar</p>
          </button>
        </DivCenter>
      </Container>
    </>
  );
}

export default Terms;
